import React from 'react';
import {Link} from 'react-router-dom';
import BalanceService from "./BalanceService";
import BalanceGridFilter from "./BalanceGridFilter";
import {BalanceStorage} from "./BalanceStorage";

export default class BalanceByBizLocationGrid {
  title = "Saldo atual por Local";
  showNewButton = false;
  showPdfButton = false;
  exportNewPage = true;
  customFilters = {};
  storage = new BalanceStorage();
  customFilterComponent = (props, state, onChange) => {
    return (
      <BalanceGridFilter
        {...props}
        onChange={value => {
          this.customFilters = value;
          onChange(value);
        }}
      />
    )
  };
  columns = [
    {
      Header: "Nome",
      accessor: "friendlyName",
      HeaderColumn: true,
      Cell: row => {

        const {id, hasDescendants} = row.original;
        const url = hasDescendants ? `/list/balance-by-biz-locations/${id}` : `/list/balance-by-product-types/biz-locations/${id}`;

        return (<Link to={url}>
          {row.original.friendlyName}
        </Link>);
      }
    },
    {
      Header: "Código ERP",
      accessor: "erpCode"
    },
    {
      Header: "Total de produtos",
      accessor: "totalAssets"
    }
  ];
  endpoint = () => {
    localStorage.clear()
    const params = new URLSearchParams({});
    if (this.customFilters.bizStep) {
      this.storage.saveBizStepData(this.customFilters.bizStep);
      params.append('bizStepIds', this.customFilters.bizStep);
    }
    if (this.customFilters.dispositionId) {
      this.storage.saveDispositionData(this.customFilters.dispositionId);
      params.append('dispositionsIds', this.customFilters.dispositionId);
    }
    if (this.customFilters.bizLocation) {
      this.storage.saveBizLocationData(this.customFilters.bizLocation);
      params.append('bizLocationIds', this.customFilters.bizLocation);
    }
    if (this.customFilters.productType) {
      this.storage.saveProductTypeDate(this.customFilters.productType);
      params.append('productTypesIds', this.customFilters.productType);
    }

    return BalanceService.BIZ_LOCATION_URL + '?' + params.toString()
  };
}



// WEBPACK FOOTER //
// ./src/balance/BalanceByBizLocationGrid.js